// -----MAIN-prodn----
export const BaseURL = "https://askcfbackend.cloudframe.com/api";
// export const BaseURL = " http://lisa.askbackend.cloudframe.com:58932";

// -----LOCAL DEV----
// export const BaseURL = "http://127.0.0.1:8000/api";
// export const BaseURL = "https://askcfbackenddev.cloudframe.com/api";
// export const MBaseURL = "https://askcfbackenddev.cloudframe.com";

// Date: 7 Aug 2026 -- Continuum KB rollout.
// Maps the chooser's stored "product" context value to the backend's product slug,
// used to scope personal/* API calls to the KB the user picked.
export const productSlug = (product) =>
  product === "continuum" ? "continuum" : "code-navigator";

// export const chatBotAPI = `http://172.206.7.224:4398`;

// NOTE (ASK.CN react18 project): 
    // 1. FEBORE production deploy DO THIS / CHECK or search exiting frontend url in vs-code like, "ask.cloudframe.com" or "http://lisa.ask.cloudframe.com:58932" it will show all files which is used in this application like this:
        // a). Header.js file
        // b). authConfig.js

    // 2. Inside compnents->
        // -----BaseURL.js file to change back-end URL.

